import { DismissablePromptKey } from '@ms/yammer-data/dist/state/types';
import { useLoadDismissablePrompts, useShouldStartDismissablePrompt } from '@ms/yammer-hooks/dist/dismissablePrompts';
import { useIsLeaderIDSmartEntryPointsEnabled } from '@ms/yammer-hooks/dist/leaderSettings';
import { useHasUserNetworkLeaders } from '@ms/yammer-hooks/dist/userNetworkLeaders';
import { UrlRootPath, getUrlRootPath } from '@ms/yammer-web-support/dist/location';
import React, { ReactNode, Suspense } from 'react';
import { useLocation } from 'react-router-dom';

import LoadableLeadershipCornerBanner from '../LoadableLeadershipCornerBanner';

const promptKeys = [DismissablePromptKey.LeadershipCornerBanner];

type UseLeadershipCornerBanner = () => ReactNode | null;
export const useLeadershipCornerBanner: UseLeadershipCornerBanner = () => {
  useLoadDismissablePrompts({ promptKeys });
  const { pathname } = useLocation();
  const urlPath = getUrlRootPath(pathname);
  const isLeadershipCornerPageUrl = urlPath === UrlRootPath.leadershipCorner;

  const isLeadershipCornerBannerPromptNotDismissed = useShouldStartDismissablePrompt(
    DismissablePromptKey.LeadershipCornerBanner
  );

  const isLeaderIDSmartEntryPointsEnabled = useIsLeaderIDSmartEntryPointsEnabled();
  const hasUserNetworkLeaders = useHasUserNetworkLeaders();

  const shouldDisplayLeadershipCornerBanner =
    isLeadershipCornerPageUrl &&
    isLeaderIDSmartEntryPointsEnabled &&
    !hasUserNetworkLeaders &&
    isLeadershipCornerBannerPromptNotDismissed;

  if (!shouldDisplayLeadershipCornerBanner) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <LoadableLeadershipCornerBanner />
    </Suspense>
  );
};
